import {
    Outgoing,
    Incoming,
    List,
    Completed,
    Dashboard,
    InOut,
    VisitorStatus,
    VisitorStatusDetails,
    VisitorDetails,
    VisitorLRCStatusDetails,
    VisitorVCardDetails,
    VisitorPCardDetails,
    VisitorLRCSummary,
    VisitorLRCUnitDetails,
    VisitorVCardActivity,
    DailyIncident,
} from "../Components/index.js";

export default [
    {
        path: "/report/rp/dashboard",
        component: Dashboard,
        name: "report.rp.dashboard",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/in-out",
        component: InOut,
        name: "report.rp.inout",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/all",
        component: List,
        name: "report.rp.all",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/completed",
        component: Completed,
        name: "report.rp.completed",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/rp/outgoing",
        component: Outgoing,
        name: "report.rp.outgoing",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/outgoing/:company",
        component: Outgoing,
        name: "report.rp.outgoing.company",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/outgoing/:company/:leaveType",
        component: Outgoing,
        name: "report.rp.outgoing.company.leaveType",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/rp/incoming",
        component: Incoming,
        name: "report.rp.incoming",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/incoming/:company",
        component: Incoming,
        name: "report.rp.incoming.company",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/incoming/:company/:leaveType",
        component: Incoming,
        name: "report.rp.incoming.company.leaveType",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/rp/visitor/status",
        component: VisitorStatus,
        name: "report.rp.user.status",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/rp/visitor/in-out",
        component: () => import("../Components/VisitorInOut.vue"),
        name: "report-rp-in-out",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/rp/visitor/status-details",
        component: VisitorStatusDetails,
        name: "report.rp.user.status.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/visitor-lrc/status-details",
        component: VisitorLRCStatusDetails,
        name: "report.rp.user.lrc.status.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/visitor-lrc/unit-details/:id",
        component: VisitorLRCUnitDetails,
        name: "report.rp.user.lrc.unit.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/visitor-without-lrc/status-details",
        component: VisitorVCardDetails,
        name: "report.rp.user.without.lrc.status.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/visitor-without-lrc/summary",
        component: VisitorLRCSummary,
        name: "report.rp.user.without.lrc.summary",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/visitor-temp/status-details",
        component: VisitorPCardDetails,
        name: "report.rp.user.tmp.status.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/visitor-details/:service_no",
        component: VisitorDetails,
        name: "report.rp.user.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/rp/visitor-v-details/:cell",
        component: VisitorVCardActivity,
        name: "report.rp.user.vcard.details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/rp/daily-incident",
        component: DailyIncident,
        name: "report.rp.daily.incident",
        meta: {
            requiresAuth: true,
        },
    },
];
